import React from 'react';

import { NavLink } from 'react-router-dom';

import { pushEvent } from '@app/components/TagManager';
import ContactUs from '@app/components/UI/ContactUs/ContactUs';
import styles from '@app/components/UI/Footer/Footer.module.scss';
import FooterMenu from '@app/components/UI/Footer/FooterMenu/FooterMenu';
import CustomModal from '@app/components/UI/Modal/CustomModal';
import PHJLogoSVG from '@app/images/PHJLogoSVG';
import logoMinLoL from '@app/images/logo_glyph_light.svg';
import IconTikTok from '@app/images/social/IconTikTok';
import IconTwitter from '@app/images/social/IconTwitter';
import iconFacebook from '@app/images/social/icon_facebook.svg';
import iconInstagram from '@app/images/social/icon_instagram.svg';
import iconLinkedin from '@app/images/social/icon_linkedin.svg';
import iconYoutube from '@app/images/social/icon_youtube.svg';
import { AppRoute } from '@app/utils/appRoutes';

const year = new Date().getFullYear();

const Footer: React.FC = () => {
	const [openContactForm, setOpenContactForm] = React.useState<boolean>(false);

	return (
		<>
			<footer className={styles.footer}>
				<div className={styles.footerWrap}>
					<div className={styles.content}>
						<div className={styles.content__left}>
							<div className={styles.phjWrap}>
								<div className={styles.phjLogo}>
									<NavLink to="/">
										<PHJLogoSVG fill="#9c8caf" />
									</NavLink>
								</div>
								<div className={styles.phjNav}>
									<ul>
										<li>
											<NavLink to={AppRoute.USING_PHJ}>
												Using Pet Hospice Journal
											</NavLink>
										</li>
										<li>
											<NavLink to={AppRoute.ABOUT}>
												About the Journal
											</NavLink>
										</li>
										<li>
											<span onClick={() => setOpenContactForm(true)}>
												Contact PHJ Support
											</span>
										</li>
									</ul>
								</div>
							</div>
							<div className={styles.lolWrap}>
								<a
									href="https://www.lapoflove.com"
									target="_blank"
									rel="noopener noreferrer"
								>
									<img
										className={styles.lolLogo}
										src={logoMinLoL}
										alt="Logo"
									/>
								</a>
								<FooterMenu />
							</div>
						</div>
						<div className={styles.contacts}>
							<div className={styles.schedule}>
								<p>
									For individual advice from a Lap of Love veterinarian on caring for your hospice pet…
								</p>
								<a
									className={`btn btn-purple-gray ${styles.btnNotMobile}`}
									href="https://www.lapoflove.com/online-booking"
									target="_blank"
									rel="noopener noreferrer"
									onClick={() => pushEvent('PHJ-ScheduleFooter')}
								>
									Schedule an Appointment
								</a>
								<a
									className={`btn btn-purple-gray ${styles.btnMobile}`}
									href="https://www.lapoflove.com/online-booking"
									target="_blank"
									rel="noopener noreferrer"
									onClick={() => pushEvent('PHJ-MobileScheduleFooter')}
								>
									Schedule an Appointment
								</a>
							</div>
							<h4 className={styles.contactsTitle}>
								<a
									className={styles.subscribeLink}
									href="https://info.lapoflove.com/senior-pet-digest"
									target="_blank"
									rel="noopener noreferrer"
								>
									Subscribe
								</a>
								<span>Subscribe</span>
								{' '}
								to the Senior Pet Digest
							</h4>
							<p className={styles.contactsText}>
								<span>
									<a
										className={styles.subscribeLink}
										href="https://info.lapoflove.com/senior-pet-digest"
										target="_blank"
										rel="noopener noreferrer"
									>
										Subscribe here
									</a>
									&nbsp; to view our monthly newsletter with helpful pet articles, insights, and resources.
								</span>
								<span className={styles.mobile}>
									To receive our monthly newsletter containing helpful articles and resources on senior pet care.
								</span>
							</p>
							<FooterMenu isMobile />
							<div className={styles.socialMedia}>
								<img
									className={styles.socialMedia__logo}
									src={logoMinLoL}
									alt="Logo"
								/>
								<div className={styles.socialMedia__content}>
									<b>Connect with us:</b>
									<div className={styles.list}>
										<a
											href="https://www.facebook.com/lapoflove"
											target="_blank"
											rel="noopener noreferrer"
										>
											<img
												src={iconFacebook}
												alt="Facebook"
											/>
										</a>
										<a
											href="https://twitter.com/LapofLoveVets"
											target="_blank"
											rel="noopener noreferrer"
											className={styles.iconWrap}
										>
											<IconTwitter />
										</a>
										<a
											href="https://www.instagram.com/lapofloveveterinaryhospice/"
											target="_blank"
											rel="noopener noreferrer"
										>
											<img
												src={iconInstagram}
												alt="Instagram"
											/>
										</a>
										<a
											href="https://www.youtube.com/user/Lapoflove"
											target="_blank"
											rel="noopener noreferrer"
										>
											<img src={iconYoutube} alt="Youtube" />
										</a>
										<a
											href="https://www.linkedin.com/company/lap-of-love-veterinary-hospice"
											target="_blank"
											rel="noopener noreferrer"
										>
											<img
												src={iconLinkedin}
												alt="Linkedin"
											/>
										</a>
										<a
											href="https://www.tiktok.com/@lapoflovevets"
											target="_blank"
											rel="noopener noreferrer"
											className={`${styles.iconWrap} ${styles.tiktok}`}
										>
											<IconTikTok />
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className={styles.bottom}>
						<span className={styles.copyright}>
							{`© 2010-${year} Lap of Love. All rights reserved.`}
						</span>
						<div className={styles.policies}>
							<a
								href="https://www.lapoflove.com/policies/privacy-policy"
								target="_blank"
								rel="noopener noreferrer"
							>
								Privacy Policy
							</a>
							<a
								href="https://www.lapoflove.com/policies/terms-and-conditions"
								target="_blank"
								rel="noopener noreferrer"
							>
								Terms and Conditions
							</a>
							<a
								href="https://www.lapoflove.com/policies/accessibility-policy"
								target="_blank"
								rel="noopener noreferrer"
							>
								Accessibility Policy
							</a>
						</div>
					</div>
				</div>
			</footer>

			{openContactForm && (
				<CustomModal
					modalVisible={openContactForm}
					setModalVisible={setOpenContactForm}
				>
					<ContactUs onChangeVisibleModal={setOpenContactForm} />
				</CustomModal>
			)}
		</>
	);
};

export default Footer;
